import { sinaClient, proxyClient, decodeClient, accumulateClient, stockStatisticsClient } from './client'
import { mapStarStock, mapHotestStock, mapSearchResult } from './map'

export default {
  async getStarStocks () {
    const url = '/PerspectiveService.getStar'
    const data = (await sinaClient.get(url)).data.result.data
    return data.map(mapStarStock)
  },

  async getStatistic () {
    const total = '/PerspectiveService.getTotal'
    const today = '/PerspectiveService.getToday'
    const res = await Promise.all([sinaClient.get(total), sinaClient.get(today)])
    return {
      total: res[0].data.result.data,
      today: res[1].data.result.data
    }
  },

  async getHostestStock () {
    const url = '/PerspectiveService.getTodayHot'
    const data = (await sinaClient.get(url)).data.result.data
    return data.map(mapHotestStock)
  },

  async search (text, types = ['11']) {
    const type = types.join(',')
    const url = `/suggest3.sinajs.cn/suggest/type=${type}&key=${text}&name=suggestdata`
    const data = (await proxyClient.get(url)).data.data
    if (!data) return []
    const stocks = data.split(';')
    return stocks.map(mapSearchResult)
  },

  async getEvaluation (symbol) {
    const url = `PerspectiveService.diagnoseWap?symbol=${symbol}&`
    const data = (await sinaClient.get(url)).data.result.data.data
    return data
  },

  async getTechnologyPerspective (symbol) {
    const url = `TzyYKPerspectiveService.techPerspective?symbol=${symbol}`
    const data = (await sinaClient.get(url)).data.result.data
    return data
  },

  async getCompareResult (symbol) {
    const url = `PerspectiveService.coefficientChart?type=wap&stock_code=${symbol}`
    const data = (await sinaClient.get(url)).data.result.data.data
    return data
  },

  async getPerspectiveChip (symbol, duration = 0) {
    const url = `chipcompany?symbol=${symbol}&duration=${duration}`
    const data = (await proxyClient.get(url)).data
    return data
  },
  async getFinanceHq (symbol) {
    const url = `t2/finance.sina.com.cn/finance/hq/${symbol}.js`
    const data = (await proxyClient.get(url)).data
    return data
  },

  async getDailyData (symbol) {
    const url = `/finance.sina.com.cn/realstock/company/${symbol}/hisdata/klc_kl.js`
    const data = (await decodeClient.get(url)).data
    return data
  },

  async getBigDataStock (symbol) {
    const url = `TzyYKPerspectiveService.bigPerspective?symbol=${symbol}`
    return (await sinaClient.get(url)).data.result.data.res
  },

  async getAchievement (symbol) {
    const url = `TzyYKPerspectiveService.valuePerspective?symbol=${symbol}`
    return (await sinaClient.get(url)).data.result.data.res
  },

  async getCapitalResult (symbol) {
    const url = `TzyYKPerspectiveService.fundPerspective?symbol=${symbol}`
    return (await sinaClient.get(url)).data.result.data.res
  },

  async getFundInflow (symbol) {
    const url = `stock.sina.com.cn/stock/api/jsonp.php/sz0000422017/TouziService.getStockHistoryMinuteFlow?symbol=${symbol}`
    return (await proxyClient.get(url)).data
  },

  async getBullBearDaily (symbol, duration) {
    const url = `bscompany?symbol=${symbol}&duration=${duration}`
    // console.log(accumulateClient.defaults.baseURL)
    return (await accumulateClient.get(url)).data
  },

  // 诊股统计
  async stockStatistics (stockId, uid) {
    const url = `/admin/diagnosis`
    return (await stockStatisticsClient.post(url, {uid, stockId})).data
  }
}



// WEBPACK FOOTER //
// ./src/plugins/stock/diagnosis.js